import React from "react";
import {useRenderPercentValue} from "../../api/utilities/useValueRenderers.js";

export default function OverviewValue({title, value, percentChange, last}) {
    let renderPercentValue = useRenderPercentValue();

    let percentChangeTextClass = 'text-emerald-500';

    if (percentChange < 0) {
        percentChangeTextClass = 'text-red-500';
    } else if (percentChange < 5) {
        percentChangeTextClass = 'text-orange-500';
    }

    return <div className="flex items-center py-2">
        <div className="mr-5">
            <div className="flex items-center">
                <div className="text-2xl font-bold text-slate-800 dark:text-slate-100 mr-2">{value}</div>
                {percentChange !== undefined && <div className={"text-sm font-medium " + percentChangeTextClass}>
                    {renderPercentValue(percentChange)}
                </div>}
            </div>
            <div className="text-sm text-slate-500 dark:text-slate-400">{title}</div>
        </div>
        {last !== true && <div
            className="hidden md:block w-px h-8 bg-slate-200 dark:bg-slate-700 mr-5"
            aria-hidden="true"
        ></div>}
    </div>;
}